var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import SearchResultList from '../SearchResultList/SearchResultList';
import './SearchResultGrid.scss';
var SearchResultGrid = /** @class */ (function (_super) {
    __extends(SearchResultGrid, _super);
    function SearchResultGrid(props) {
        return _super.call(this, props) || this;
    }
    SearchResultGrid.prototype.render = function () {
        var _a;
        var postResults = [];
        var pageResults = [];
        var planResults = [];
        var tagResults = this.props.tagResultsArray;
        (_a = this.props.postPagePlanResultsArray) === null || _a === void 0 ? void 0 : _a.map(function (result) {
            if (result.type == 'post') {
                postResults.push(result);
            }
            else if (result.type == 'page') {
                pageResults.push(result);
            }
            else if (result.type == 'plans') {
                planResults.push(result);
            }
        });
        if (pageResults.length == 0 && planResults.length == 0 && postResults.length == 0 && tagResults.length == 0) {
            return (React.createElement("div", { className: "searchResultGrid no-results" },
                React.createElement("p", null,
                    React.createElement("span", null, "Nothing relevant found! Try using a different search term or "),
                    React.createElement("a", { href: "/?s=" + this.props.searchQuery },
                        "see all results for ",
                        this.props.searchQuery))));
        }
        return (React.createElement("div", { className: "searchResultGrid" },
            React.createElement("div", { className: "wrapper" },
                React.createElement(SearchResultList, { resultType: "Pages", resultsArray: pageResults }),
                React.createElement(SearchResultList, { resultType: "Plans", resultsArray: planResults })),
            React.createElement("div", { className: 'wrapper' },
                React.createElement(SearchResultList, { resultType: "Tags", resultsArray: tagResults }),
                React.createElement(SearchResultList, { resultType: "Posts", resultsArray: postResults }))));
        // if(this.props.postPagePlanResultsArray && this.props.tagResultsArray) {
        //   return(
        //   )
        // }
    };
    return SearchResultGrid;
}(React.Component));
export default SearchResultGrid;
